import script from "./immediately-process.vue?vue&type=script&setup=true&lang=js"
export * from "./immediately-process.vue?vue&type=script&setup=true&lang=js"

import "./immediately-process.vue?vue&type=style&index=0&id=793c46aa&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-793c46aa"]])

export default __exports__